    export function getLabelAndCount(item,categories) {

     if(item.categoryName=='All'){
          
         const sum = categories.filter(i => i.categoryName !== 'All' || i.documentCategoryCount==null).reduce((acc,ele)=>{
            return acc+ele.documentCategoryCount
          },0)

          if(isNaN(sum)){
            return item.categoryName
          }

          return `${item.categoryName}(${sum})`

        }

      if(item.documentCategoryCount!==null){

   
        return `${item.categoryName}(${item.documentCategoryCount})`

      }
      else{

                return `${item.categoryName}`

      }
    }
